








































import {Component, Mixins, Prop, Ref, Vue} from 'vue-property-decorator';
import {ActiveInject, ActiveProvide} from "@/support/reactive"
import {uuidv4} from '@/design-system/utilities/Uuid';
import MonitorMixin from "@/design-system/utilities/MonitorMixin"

/**
 * @status stable
 * @published 4.5.0
 * @changelog 4.5.0 Published.
 * @changelog 4.8.7 Shrink down to 250px on most screens.
 */
@Component({
    components: {}
})
export default class JdsPipelineStage extends Mixins(MonitorMixin) {
    @Ref() topEl!: HTMLElement
    @Ref() bottomEl!: HTMLElement
    @Ref() scrollerEl!: HTMLElement
    @Ref() stageEl!: HTMLElement

    observer!: IntersectionObserver
    topIsVisible = true
    bottomIsVisible = true
    mouseOver = false

    @ActiveInject({ from: 'jds.pipeline.dragging', default: false }) dragging!: boolean
    @ActiveInject({from: 'jds.pipeline.bus', default: null}) bus!: Vue

    @ActiveInject({from: 'jds.pipeline.is-selecting', default: false}) pipelineIsSelecting!: boolean
    @ActiveInject({from: 'jds.pipeline.select-mode', default: 'none'}) pipelineSelectMode!: string
    @ActiveInject({from: 'jds.pipeline.selected-stage', default: null}) pipelineSelectedStage!: string
    @ActiveInject({ from: 'jds.pipeline.selected-cards', default: [] }) selectedCards!: string[]


    /**
     * Unique ID of this stage. It only needs to be unique within the context of _this pipeline_ instance.
     *
     * Emitted as part of the pipeline's `drop` event.
     */
    @ActiveProvide('jds.pipeline.stage.id')
    @Prop({ default: uuidv4 }) uid!: string

    @Prop({type: Boolean, default: false}) drawer!: boolean

    @Prop() icon!: string

    /**
     * Where to redirect when clicking on the stage header.
     */
    @Prop() headerTo!: Location

    beforeMount() {
        if (this.bus) {
            this.bus.$on('dragStart', () => {
                // reset state on drag start
                this.mouseOver = false;
            })
        } else {
            this.$warn('Unable to communicate to pipeline bus.')
        }
    }

    handleMouseEnter() {
        if (this.dragging) {
            this.mouseOver = true;
            this.bus.$emit('dropTargetEnter', {
                targetId: this.uid,
            })
        }
    }

    handleMouseLeave() {
        if (this.dragging) {
            this.mouseOver = false;
            this.bus.$emit('dropTargetLeave', {
                targetId: this.uid,
            })
        }
    }

    get allowSelect() {
        if (this.pipelineSelectMode === 'none') return false;
        if (this.pipelineSelectMode === 'per-stage' && this.pipelineIsSelecting) {
            if (this.selectedCards.length === 0) return true
            return this.uid === this.pipelineSelectedStage
        }
        return false; // just a failsafe for invalid values
    }

    mounted() {

        this.observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if ((entry.target as HTMLElement).dataset['sense'] === 'top') {
                    this.topIsVisible = entry.isIntersecting
                } else {
                    this.bottomIsVisible = entry.isIntersecting
                }
            })
        }, {
            root: this.scrollerEl,
            threshold: 1
        })
        this.observer.observe(this.topEl)
        this.observer.observe(this.bottomEl)

        this.stageEl.addEventListener('pointerenter', this.handleMouseEnter)
        this.stageEl.addEventListener('pointerleave', this.handleMouseLeave)
    }

    beforeDestroy() {
        delete this.observer
    }

    get stageClasses() {
        return {
            'jdsc-pipeline-stage--highlight': (this.dragging && this.mouseOver),
            'jdsc-pipeline-stage--drawer': this.drawer,
        }
    }
}
